import { Box, Typography, TextField,IconButton } from "@material-ui/core";
import DeleteOutlineRoundedIcon from '@material-ui/icons/DeleteOutlineRounded';
export default function ItemQuantityControl({ label, quantity, onChange, onDelete }) {
  
  const handleInputChange = (e) => {
    const value = parseInt(e.target.value, 10);
      onChange(value);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      border={1}
      borderRadius={8}
      borderColor="grey.300"
      padding={1}
      mb={1}
    >
      <Typography
        variant="body1"
        style={{ minWidth: 100, lineBreak: "anywhere", marginRight: 8 }}
      >
        {label}
      </Typography>

      <Box display="flex" alignItems="center" gap={1}>
        <TextField
          variant="outlined"
          size="small"
          type="number"
          value={quantity}
          onChange={handleInputChange}
          inputProps={{ min: 1 }}
          style={{ minWidth: 80 }}
        />
      </Box>

      <Box ml={2}>
        <IconButton onClick={onDelete} color="default">
          <DeleteOutlineRoundedIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}